import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { LucideAngularModule, PanelRightClose, PanelRightOpen, X } from 'lucide-angular';
import { NavigationMenuComponent } from '@shared/components/navigation-menu/navigation-menu.component';
import { UserBubbleComponent } from '@shared/components/user-bubble/user-bubble.component';
import { NgClass } from '@angular/common';
import { CollapseService } from '@app/core/services/collapse.service';
import { UserService } from '@app/core/services/user.service';
import { AppConfigService } from '@app/core/config/app-config.service';
import { TooltipDirective } from '@shared/directives/tooltip/tooltip.directive';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * Represents the navigation component for the application.
 * Provides functionalities such as displaying user information, managing navigation,
 * and handling global search interactions.
 *
 */
@Component({
  selector: 'app-navigation',
  imports: [
    RouterLink,
    LucideAngularModule,
    NavigationMenuComponent,
    UserBubbleComponent,
    RouterLinkActive,
    NgClass,
    TooltipDirective,
    TranslatePipe,
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.css',
  standalone: true,
  providers: []
})
export class NavigationComponent {
  /**
   * Constructor for initializing the class with dependencies.
   *
   * @param {CollapseService} collapseService - The service responsible for handling collapse-related operations.
   * @param {UserService} userService - The service responsible for user-related operations.
   * @param {AppConfigService} configService - The service providing runtime application configuration.
   * @param {Router} router - The Angular Router to handle navigation and routing.
   * @return {void}
   */

  constructor(
    public readonly collapseService: CollapseService,
    public readonly userService: UserService,
    public readonly configService: AppConfigService,
    private readonly router: Router,
  ) {}

  get showEnvironment(): boolean {
    const env = this.configService.settings?.environmentName?.toLowerCase();
    return !!env && env !== 'prod' && env !== 'production';
  }

  protected readonly X = X;
  protected readonly PanelRightOpen = PanelRightOpen;
  protected readonly PanelRightClose = PanelRightClose;
}
